<template>
  <section class="mt-16">
      <v-breadcrumbs
        large
        :items="crumbs"
        divider="/"
        class="pl-0"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-account-multiple</v-icon> <span>Registo de Utilizador</span>
      </h1>

      <div class="mt-16">
        <user method="create"></user>
      </div>
  </section>
</template>
<script>
import User from '@/components/users/User'

export default {
  components: {
    User
  },
  beforeCreate(){
    document.title = "MatchCalendar - Registo de Utilizadores";
  },
  data: () => ({
    
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "users.create"])) {
      this.$router.push('/no-permission');
    }

  },
  methods:{
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/admin',
          exact: true,
        },
        {
          text: 'Gestão Utilizadores',
          disabled: false,
          to: '/admin/settings/users',
          exact: true,
        },
        {
          text: 'Registo de Utilizador',
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
